import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../css/BoardList.css";
import "../css/JobBoardList.css";

const BoardList = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const postsPerPage = 10;
  const pageLimit = 5;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get("http://35.192.131.111/board/all/");
        const enrichedData = response.data.data.map((post, index) => ({
          // data에 접근하도록 수정
          id: post.board_id, // board_id로 수정
          title: post.title,
          author: post.user, // 응답에서 제공된 user 필드를 사용
          date: post.created_At.substring(0, 10), // created_At 날짜만 추출
          views: Math.floor(Math.random() * 100), // 임의의 조회수 추가
        }));
        setPosts(enrichedData);
        setLoading(false);
      } catch (err) {
        setError("데이터를 불러오는 데 실패했습니다.");
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const totalPages = Math.ceil(posts.length / postsPerPage);
  const [currentPageGroup, setCurrentPageGroup] = useState(1);
  const totalPageGroups = Math.ceil(totalPages / pageLimit);

  const getPageNumbers = () => {
    const start = (currentPageGroup - 1) * pageLimit + 1;
    const end = Math.min(start + pageLimit - 1, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPageGroup = () => {
    if (currentPageGroup < totalPageGroups) {
      setCurrentPageGroup(currentPageGroup + 1);
      setCurrentPage((currentPageGroup + 1 - 1) * pageLimit + 1);
    }
  };

  const goToPreviousPageGroup = () => {
    if (currentPageGroup > 1) {
      setCurrentPageGroup(currentPageGroup - 1);
      setCurrentPage((currentPageGroup - 1) * pageLimit + 1);
    }
  };

  if (loading) return <p>로딩 중...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="board-list">
      <h1>자유게시판</h1>
      <p>여기는 자유롭게 글을 남길 수 있는 공간입니다.</p>
      {posts.length === 0 ? (
        <p>게시글이 없습니다. 첫 번째 게시글을 작성해 보세요!</p>
      ) : (
        <table className="board-table">
          <thead>
            <tr>
              <th>번호</th>
              <th>제목</th>
              <th>작성자</th>
              <th>작성일</th>
              <th>조회수</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((post) => (
              <tr key={post.id}>
                <td>{post.id}</td>
                <td>
                  <Link to={`/board/${post.id}`}>{post.title}</Link>
                </td>
                <td>{post.author}</td>
                <td>{post.date}</td>
                <td>{post.views}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="pagination">
        <button
          className="pagination-button"
          onClick={goToPreviousPageGroup}
          disabled={currentPageGroup === 1}
        >
          &lt;
        </button>
        {getPageNumbers().map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`pagination-button ${
              number === currentPage ? "active" : ""
            }`}
          >
            {number}
          </button>
        ))}
        <button
          className="pagination-button"
          onClick={goToNextPageGroup}
          disabled={currentPageGroup === totalPageGroups}
        >
          &gt;
        </button>
      </div>

      <Link to="/board/new" className="new-post-link">
        새 글 작성
      </Link>
    </div>
  );
};

export default BoardList;
